/**** UTILISATEUR *****/

export const ADMIN_UTILISATEURS_INITIATE_FETCH_UTILISATEUR = 'ADMIN_UTILISATEURS_INITIATE_FETCH_UTILISATEUR';
export const ADMIN_UTILISATEURS_FETCH_UTILISATEUR_START = 'ADMIN_UTILISATEURS_FETCH_UTILISATEUR_START';
export const ADMIN_UTILISATEURS_FETCH_UTILISATEUR_SUCCESS = 'ADMIN_UTILISATEURS_FETCH_UTILISATEUR_SUCCESS';
export const ADMIN_UTILISATEURS_FETCH_UTILISATEUR_FAIL = 'ADMIN_UTILISATEURS_FETCH_UTILISATEUR_FAIL';
export const ADMIN_UTILISATEURS_FETCH_UTILISATEUR_RESET = 'ADMIN_UTILISATEURS_FETCH_UTILISATEUR_RESET';
